import { variantHandler } from '../../utils';

export default function getVariant(settings) {
  const { variant } = settings;
  if (!variant) return [null, {}];

  const { VariantComponent, getSettings } = variantHandler.get(variant) || {};

  const variantSettings =
    !!getSettings && typeof getSettings === 'function' ? getSettings(settings) : settings;

  return [VariantComponent, variantSettings];
}
